import styled from "styled-components";

export const Wrapper = styled.div`
  background-color: white;
  box-shadow: 0px 6px 10px 0px rgba(0, 0, 0, 0.2);
  border-radius: 0.6rem;
  width: 100%;
  display: flex;
`;
